import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import CommonModal from '../CommonModal';

interface IDeleteModalProps {
    moduleName?: string;
    moduleTitle?: any;
    moduleDeleteModalContent?: any;
    handleClose(status: boolean): any;
    isDeleteLoading?: boolean;
    primaryBtnText?: string;
    dangerBtnText?: string;
    secondaryBtnText?: string;
}

const DeleteModal = ({ moduleName, moduleTitle, moduleDeleteModalContent, handleClose, isDeleteLoading = false, dangerBtnText = 'Delete' }: IDeleteModalProps) => {
    const { t } = useTranslation();

    return (
        <CommonModal
            title={
                moduleTitle ?? (
                    <span className="line-clamp-2 word-break">
                        {t('Common.Delete')} {moduleName}
                    </span>
                )
            }
            modalTitleDesc={
                moduleDeleteModalContent
                    ? moduleDeleteModalContent
                    : t('components.deleteModal.Delete_confirmation', {
                          moduleName: moduleName,
                      })
            }
            size="max-w-[400px]"
            handleClose={() => (isDeleteLoading ? false : handleClose(false)())}
            modalHeaderClass="border-b-0 !px-6 !pt-6 !pb-5 !bg-transparent"
            modalHeaderTextClass="!flex-col"
            modalFooterClass="border-t-0 !bg-transparent"
            closeBtnClass="-mt-2 -mr-2"
            secondaryBtnOnClick={handleClose(false)}
            secondaryBtnDisabled={isDeleteLoading}
            dangerBtnText={dangerBtnText}
            secondaryBtnText={t('Common.Cancel')}
            primaryBtnOnClick={handleClose(true)}
            primaryBtnDisabled={isDeleteLoading}
            primaryBtnLoading={isDeleteLoading}
            closeOnOutsideClick={true}
        >
            <></>
        </CommonModal>
    );
};

export default memo(DeleteModal);
